export const useLineHref = () => {
  const getDomain = () => {
    const config = useRuntimeConfig().public
    const { NAME, DOMAIN_NAME } = config
    return NAME === 'prod'
      ? `https://m.${DOMAIN_NAME}`
      : `https://m-${NAME}.${DOMAIN_NAME}`
  }

  const getLineHref = (path: any, lang = '') => {
    return path ? `${getDomain()}${lang}${path}` : ''
  }

  return {
    getLineHref,
  }
}
